module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAYAAACEJVa/AAAAu0lEQVQokWP4bykj9NVa6T+5+L+5Ch/DN2f5/5Rihm/eMv8pxQzfgiRffA+W+k8u/hYs9ZaBgYGB4Ue0+H9yMQMM/A9lYP6ZLPKfVPw/lIGZARl8zhAX+5kl+J9Y/DlDXIwBG/hdJGT1q4j/PyH8u0jICqsBMPC3hiv7dxXPf1z4bw1XNl4DYOBPI+eKP02c/zFwI+cKogyAu6ib7fKfLrb/MPy3k+0SSQbAwL9JrA/+TmL5/3cS60N86gD9UVZNt7cXxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/x.png
// module id = i6yt
// module chunks = 2